import { gql } from '@apollo/client'

// Add new Boat
export const MARK_COMPLETE_VESSEL_DEFECT = gql`
    mutation MarkCompleteVesselDefect(
        $inspectionReport: VesselDefectInspectionReportInput!
        $defectDate: LocalDate!
        $defectSubmissionId: NonEmptyString!
    ) {
        markCompleteVesselDefect(
            inspection_report: $inspectionReport
            defect_date: $defectDate
            defect_submission_id: $defectSubmissionId
        ) {
            code
            success
            message
        }
    }
`

export const CANCEL_BOAT_ROUTE_TRIP = gql`
    mutation CancelBoatRouteTrip($historyId: NonEmptyString!, $tripDate: LocalDate!) {
        cancelBoatRouteTrip(history_id: $historyId, trip_date: $tripDate) {
            code
            success
            message
        }
    }
`

export const ACTIVATE_BOAT_ROUTE_TRIP = gql`
    mutation ActivateBoatRouteTrip($historyId: NonEmptyString!, $tripDate: LocalDate!) {
        activateBoatRouteTrip(history_id: $historyId, trip_date: $tripDate) {
            code
            success
            message
        }
    }
`

export const UPDATE_ROUTE_TRIP_WAYPOINT_STATUS = gql`
    mutation UpdateRouteTripWaypointStatus($tripLocation: UpdateRouteTripWaypointStatusInput!) {
        updateRouteTripWaypointStatus(trip_location: $tripLocation) {
            code
            success
            message
        }
    }
`

export const REMOVE_BOAT_ROUTE_ADDITIONAL_CAPTAIN = gql`
    mutation RemoveBoatRouteAdditionalCaptain($historyId: NonEmptyString!, $activityDate: LocalDate!) {
        removeBoatRouteAdditionalCaptain(history_id: $historyId, activity_date: $activityDate) {
            code
            success
            message
        }
    }
`

export const PASSENGER_COUNTER_CHECKIN = gql`
    mutation PassengerCounterCheckin($passengerCheckinDetails: BookingPassengerCheckinInput!) {
        passengerCounterCheckin(passenger_checkin_details: $passengerCheckinDetails) {
            code
            success
            message 
            checkins {
                checkin_id
                booking_id
                passenger_id
                luggage_count
                travel_date
                status { 
                    code
                    description {
                        en
                        ar
                    }
                }
                details {
                    remarks
                    counter_no  
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
                luggages {
                    booking_id
                    checkin_id
                    travel_date
                    luggage_id
                    qr_code {
                        encrypted
                    }
                    status { 
                        code    
                        description {
                            en
                            ar
                        }
                    }
                    details { 
                        weight  
                        dimensions {
                            length
                            width
                            height
                        }   
                        color
                        tags
                    }   
                    user_audit {
                        created_by
                        created_date
                        modified_by
                        modified_date
                    }
                } 
            }
        }
    }
`

export const UPDATE_BOOKING_PASSENGER_LUGGAGE = gql`
    mutation updateBookingPassengerLuggage($luggage: BookingPassengerLuggageInput!) {
        updateBookingPassengerLuggage(luggage: $luggage) {
            code
            success
            message
            luggage {
                booking_id
                checkin_id
                travel_date
                luggage_id
                status { 
                    code    
                    description {
                        en
                        ar
                    }
                }
            }
        }
    }
`

export const COMPLETE_PASSENGER_COUNTER_CHECKIN = gql`
    mutation CompletePassengerCounterCheckin(
        $bookingId: NonEmptyString!
        $travelDate: LocalDate!
        $tripId: NonEmptyString!
    ) {
        completePassengerCounterCheckin(booking_id: $bookingId, travel_date: $travelDate, trip_id: $tripId) {
            code
            success
            message
        }
    }
`

export const ADD_PASSENGER_LUGGAGE = gql`
    mutation addPassengerLuggage($booking_id: NonEmptyString!, $checkin_id: NonEmptyString!) {
        addPassengerLuggage(booking_id: $booking_id, checkin_id: $checkin_id) {
            code
            success
            message
            luggage {
                booking_id
                checkin_id
                travel_date
                luggage_id
                status { 
                    code    
                    description {
                        en
                        ar
                    }
                }
                details { 
                    weight  
                    dimensions {
                        length
                        width
                        height
                    }   
                    color
                    tags
                }   
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
            } 
        }
    }
`

export const REMOVE_PASSENGER_LUGGAGE = gql`
    mutation removePassengerLuggage($booking_id: NonEmptyString!, $checkin_id: NonEmptyString!, $luggage_id: NonEmptyString!) {
        removePassengerLuggage(booking_id: $booking_id, checkin_id: $checkin_id, luggage_id: $luggage_id) {
            code
            success
            message
        }
    }
`

export const PRINT_PASSENGER_LUGGAGE_TAG = gql`
    mutation PrintPassengerLuggageTag($bookingId: NonEmptyString!, $checkinId: NonEmptyString!, $luggageId: NonEmptyString!) {
        printPassengerLuggageTag(booking_id: $bookingId, checkin_id: $checkinId, luggage_id: $luggageId) {
            code
            success
            message
            zplData
        }
    }
`

export const TRIGGER_RECIPIENT_EMAIL = gql`
    mutation TriggerRecipientEmail($historyId: NonEmptyString!, $routeId: NonEmptyString!, $tripDate: LocalDate!, $passengerStatus: PassengerStatus!) {
        triggerRecipientEmail(history_id: $historyId, route_id: $routeId, trip_date: $tripDate, passenger_status: $passengerStatus) {
            code
            success
            message
        }
    }
`

export const DOWNLOAD_PASSENGER_MANIFEST = gql`
    mutation DownloadPassengerManifest($type: ManifestDocumentType!, $routeId: NonEmptyString!, $tripDate: LocalDate!, $passengerStatus: PassengerStatus!, $historyId: NonEmptyString!) {
        downloadPassengerManifest(type: $type, route_id: $routeId, trip_date: $tripDate, passenger_status: $passengerStatus, history_id: $historyId) {
            code
            success
            message
            url
        }
    }
`

export const BLOCK_OR_UNBLOCK_SEATS = gql`
    mutation BlockOrUnblockSeats($input: BlockOrUnblockSeatsInput!) {
        blockOrUnblockSeats(input: $input) {
            code
            success
            message
        }
    }
`
export const RESCHEDULE_BOAT_ROUTE_TRIP = gql`
mutation RescheduleBoatRouteTrip($tripId: NonEmptyString!, $tripDate: LocalDate!, $reschedule: RescheduleInput!) {
  rescheduleBoatRouteTrip(trip_id: $tripId, trip_date: $tripDate, reschedule: $reschedule) {
    code
    success
    message
  }
}
`

export const SEND_ADMIN_PUSH_NOTIFICATION = gql`
    mutation SendAdminPushNotification($notification: AdminPushNotificationInput!) {
        sendAdminPushNotification(notification: $notification) {
            code
            success
            message
        }
    }
`
